//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { xtLoginJsPath } from '@/config/project-config'
import { Toast} from 'vant';
export default {
  name: "footer",
  data() {
    return {
      menus: this.$store.getters['home/getMenus'], // 菜单
      jgMenus: this.$store.getters['home/getJgMenus'], // 机构菜单
      menuActive: this.$store.getters["home/getMenuActive"], // 选中的菜单
      menuStyle: this.$store.getters['home/getMenuStyle'] ,// 选中菜单样式
      menuJgActive: this.$store.getters['home/getMenuJgActive'], // 选中的机构菜单节点
      showMenuType: this.$store.getters['home/getShowMenuType'],//0显示平台头部按钮  1显示机构头部按钮
      xtLoginJsPath,

    };
  },
  methods: {
    // fnGoToPage(param) { // 跳转页面
    //   this.$store.dispatch('home/fnGoToPage', param).then(res=>{
    //     if(res != null && res != "" && res != "userCenter_demand" && res.indexOf("companyInfoList") < 0){
    //       this.$router.push({ path: res })
    //     }else if(res != null  && res != ""  &&  res == "userCenter_demand"){
    //        this.fnGotoUserCenter({self_redirect: '0',second_redirect_uri:'demand',state:'preweb'})
    //     }else if(res != null  && res != ""  &&  res.indexOf("companyInfoList") > -1){
    //        this.fnGotoSearchPage(2);
    //     }else{ 
    //       Toast("敬请期待")
    //     }
    //   })
    // },

    fnGoToPage(param) { // 跳转页面
      this.$store.dispatch('home/fnGoToPage', param).then(res=>{
        this.showMenuType = 0
        if(res != null && res != "" && res.indexOf("companyInfoList") < 0){
          this.$router.push({ path: res })
        }else if(res != null  && res != ""  &&  res.indexOf("companyInfoList") > -1){
           this.fnGotoSearchPage(2);
        }else{
          Toast("敬请期待")
        }
      })
    },
    fnGoToJgPage(param) { // 跳转机构页面
      this.$store.dispatch('home/fnGoToJgPage', param).then(res=>{
        this.showMenuType = 1
        if(res != null && res != "" && res.indexOf("companyInfoList") < 0){
          this.$router.push({ path: res })
        }else if(res != null  && res != ""  &&  res.indexOf("companyInfoList") > -1){
           this.fnGotoSearchPage(2);
        }else{
          Toast("敬请期待")
        }
      })
    },


    //跳转到找合作  搜索页直接查企业
    fnGotoSearchPage(selType){
      this.$router.push({path: '/search', query: {selType:selType}});
    },
    fnGotoOnlineYX(){
      Toast("敬请期待");
    },
    fnGotoOnlineAZ(){
      Toast("敬请期待");
    },


    fnGetMenuStyle() { // 获取当前使用的菜单样式
      let path = this.$route.path
      this.$store.dispatch("home/fnGetMenuStyle", path).then(res=>{
        this.menuStyle = res
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/footer/footer.vue